const cs_local_storage_keys = {
    AUTH_TOKEN: 'costasiella:authToken',
    AUTH_TOKEN_EXP: 'costasiella:authTokenExp',
    AUTH_TOKEN_ORIGIAT: 'costasiella:authTokenorigIat',
    AUTH_REFRESH_TOKEN: 'costasiella:authRefreshToken', 
    AUTH_REFRESH_TOKEN_EXP: 'costasiella:refreshTokenExp',
    AUTH_LOGIN_NEXT: 'costasiella:authLoginNext',
    FINANCE_EXPENSES_FILTER_DATE_FROM: 'costasiella:financeExpensesFilterDateFrom',
    FINANCE_EXPENSES_FILTER_DATE_UNTIL: 'costasiella:financeExpensesFilterDateUntil',
    FINANCE_EXPENSES_FILTER_SUPPLIER: 'costasiella:financeExpensesFilterSupplier',
    FINANCE_INVOICES_FILTER_DATE_FROM: 'costasiella:financeInvoicesFilterDateFrom',
    FINANCE_INVOICES_FILTER_DATE_UNTIL: 'costasiella:financeInvoicesFilterDateUntil',
    FINANCE_INVOICES_FILTER_SEARCH: 'costasiella:financeInvoicesFilterSearch',
    FINANCE_INVOICES_FILTER_STATUS: 'costasiella:financeInvoicesFilterStatus',
    FINANCE_INVOICES_EDIT_RETURN: 'costasiella:financeInvoicesEditReturn',
    FINANCE_ORDERS_FILTER_STATUS: 'costasiella:financeOrdersFilterStatus',
    FINANCE_QUOTES_EDIT_RETURN: 'costasiella:financeQuotesEditReturn',
    FINANCE_QUOTES_FILTER_STATUS: 'costasiella:financeQuotesFilterStatus',
    FINANCE_PAYMENT_BATCH_CATEGORIES_SHOW_ARCHIVE: 'costasiella:financePaymentBatchCategoriesShowArchive',
    INSIGHT_CLASSPASSES_YEAR: 'costasiella:insightClasspassesYear',
    INSIGHT_REVENUE_YEAR: 'costasiella:insightRevenueYear',
    INSIGHT_SUBSCRIPTIONS_YEAR: 'costasiella:insightSubscriptionsYear',
    INSIGHT_TRIALPASSES_YEAR: 'costasiella:insightTrialpassesYear',
    INSIGHT_TRIALPASSES_MONTH: 'costasiella:insightTrialpassesMonth',
    ORGANIZATION_CLASSTYPES_ARCHIVED: 'costasiella:organizationClasstypesArchived',
    RELATIONS_ACCOUNTS_FILTER_TYPE: 'costasiella:relationsAccountsFilterType',
    RELATIONS_ACCOUNTS_SEARCH: 'costasiella:relationsAccountsSearch',
    RELATIONS_ACCOUNTS_IS_ACTIVE: 'costasiella:relationsAccountsIsActive',
    RELATIONS_ACCOUNT_NOTES_NOTE_TYPE: 'costasiella:relationsAccountNotesNoteType',
    RELATIONS_ACCOUNT_PROFILE_RETURN: 'costasiella:relationsAccountProfileReturn',
    RELATIONS_BUSINESSES_EDIT_RETURN: 'costasiella:relationsBusinessEditReturn',
    RELATIONS_BUSINESSES_SHOW_ARCHIVE: 'costasiella:relationsBusinessesShowArchive',
    RELATIONS_BUSINESSES_SEARCH: 'costasiella:relationsBusinessesSeach',
    SCHEDULE_APPOINTMENTS_DATE_FROM: 'costasiella:scheduleAppointmentsDateFrom',
    SCHEDULE_APPOINTMENTS_DATE_UNTIL: 'costasiella:scheduleAppointmentsDateUntil',
    SCHEDULE_APPOINTMENTS_ORDER_BY: 'costasiella:scheduleAppointmentsOrderBy',
    SCHEDULE_APPOINTMENTS_FILTER_CLASSTYPE: 'costasiella:scheduleAppointmentsFilterClasstype',
    SCHEDULE_APPOINTMENTS_FILTER_LOCATION: 'costasiella:scheduleAppointmentsFilterLocation',
    SCHEDULE_CLASSES_BOOK_RETURN: "costasiella:scheduleClassesBookReturn",
    SCHEDULE_CLASSES_DATE_FROM: 'costasiella:scheduleClassesDateFrom',
    SCHEDULE_CLASSES_DATE_UNTIL: 'costasiella:scheduleClassesDateUntil',
    SCHEDULE_CLASSES_ORDER_BY: 'costasiella:scheduleClassesOrderBy',
    SCHEDULE_CLASSES_FILTER_CLASSTYPE: 'costasiella:scheduleClassesFilterClasstype',
    SCHEDULE_CLASSES_FILTER_INSTRUCTOR: 'costasiella:scheduleClassesFilterInstructor',
    SCHEDULE_CLASSES_FILTER_LEVEL: 'costasiella:scheduleClassesFilterLevel',
    SCHEDULE_CLASSES_FILTER_LOCATION: 'costasiella:scheduleClassesFilterLocation',
    SCHEDULE_CLASSES_ENROLLMENT_SEARCH: 'costasiella:scheduleClassesEnrollmentSearch',
    SCHEDULE_CLASSES_ENROLLMENT_RETURN: 'costasiella:scheduleClassesEnrollmentReturn',
    SCHEDULE_CLASSES_CLASS_ATTENDANCE_SEARCH: 'costasiella:scheduleClassesClassAttendanceSearch',
    SCHEDULE_EVENTS_ARCHIVED: 'costasiella:scheduleEventsArchived',
    SCHEDULE_EVENTS_TICKETS_CUSTOMERS_SEARCH: 'costasiella:scheduleEventsTicketsCustomersSearch',
    SCHEDULE_SHIFTS_DATE_FROM: 'costasiella:scheduleShiftsDateFrom',
    SCHEDULE_SHIFTS_DATE_UNTIL: 'costasiella:scheduleShiftsDateUntil',
    SCHEDULE_SHIFTS_ORDER_BY: 'costasiella:scheduleShiftsOrderBy',
    SCHEDULE_SHIFTS_FILTER_SHIFT: 'costasiella:scheduleShitsFilterShift',
    SCHEDULE_SHIFTS_FILTER_LOCATION: 'costasiella:scheduleShiftsFilterLocation',
    SELFCHECKIN_CHECKIN_SEARCH: 'costasiella:SelfcheckinCheckinSearch',
    SHOP_ACCOUNT_BANK_ACCOUNT_NEXT: 'costasiella:ShopAccountBankAccountNext',
    SHOP_ACCOUNT_PROFILE_NEXT: 'costasiella:ShopAccountProfileNext',
    SHOP_CLASSES_DATE_FROM: 'costasiella:shopClassesDateFrom',
    SHOP_CLASSES_DATE_UNTIL: 'costasiella:shopClassesDateUntil',
    SHOP_CLASSES_ORDER_BY: 'costasiella:shopClassesOrderBy',
    SHOP_CLASSES_FILTER_CLASSTYPE: 'costasiella:shopClassesFilterClasstype',
    SHOP_CLASSES_FILTER_INSTRUCTOR: 'costasiella:shopClassesFilterInstructor',
    SHOP_CLASSES_FILTER_LEVEL: 'costasiella:shopClassesFilterLevel',
    SHOP_CLASSES_FILTER_LOCATION: 'costasiella:shopClassesFilterLocation',
}

export default cs_local_storage_keys
